// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { alpha } from '@mui/material/styles';

const styles = (theme: any) => ({
  badge: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    minWidth: 0,
  },
  // Floating over a card's image, so it carries its own near-opaque ground.
  overlay: {
    position: 'absolute',
    bottom: theme.spacing(1),
    left: theme.spacing(1),
    maxWidth: `calc(100% - ${theme.spacing(2)})`,
    backgroundColor: alpha(theme.palette.common.white, 0.92),
    borderRadius: theme.spacing(1.5),
    padding: theme.spacing(0.25, 1),
  },
  // Sitting in a row's meta line, where the card behind it is already white.
  inline: {
    maxWidth: '180px',
  },
  icon: {
    color: theme.palette.primary.main,
  },
  text: {
    color: theme.palette.common.black,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export default styles;
